import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TipoCredito } from 'src/app/models/enum/tipo-credito.enum';
import { TipoInstitucion } from 'src/app/models/enum/tipo-institucion.enum';
import { PersonaPasivos } from 'src/app/models/pasivo.model';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-pasivos',
  templateUrl: './pasivos.component.html',
  styleUrls: ['./pasivos.component.css']
})
export class PasivosComponent implements OnInit {
  formArray: FormArray<FormGroup<any>> = new FormArray<FormGroup<any>>([]);
  pasivos: PersonaPasivos[] = [];
  tipoInstitucion: TipoInstitucion | any = TipoInstitucion;
  tiposCredito: TipoCredito | any = TipoCredito;
  estadoSituacionGuid: any;
  persona: any;
  formFirmado = false;
  constructor(private fb: FormBuilder, private stepperService: StepperService, private dataService: DataService, private personaService: PersonaService) { }

  ngOnInit(): void {
    this.personaService.persona$.subscribe({
      next: (persona) => {
        if (persona) {
          this.persona = persona;
          this.estadoSituacionGuid = persona.estadoSituacion.guid;
          this.formArray = this.fb.array<FormGroup<any>>([]);
          if(persona.estadoSituacion.personaPasivos?.length > 0){
            for (let i = 0; i < persona.estadoSituacion.personaPasivos?.length; i++) {
              this.agregarPasivo(persona.estadoSituacion.personaPasivos[i]);
            }
          }else{
            this.agregarPasivo(null)
          }
          if (persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
            this.formFirmado = true;
            this.formArray.disable();
          }
        }
      },
      error: (err) => console.log(err)
    });
  }

  agregarPasivo(pasivo : any): void {
    if (this.formArray.length > 0 && this.formArray.at(this.formArray.length - 1).invalid) {
      this.formArray.at(this.formArray.length - 1).markAllAsTouched();
      return;
    }
    const nuevoPasivo = this.fb.group({
      estadoSituacionId: new FormControl(this.estadoSituacionGuid),
      guid: new FormControl(pasivo?.guid),
      institucion: new FormControl(pasivo?.institucion, [Validators.required]),
      tipoCredito: new FormControl(pasivo?.tipoCredito, [Validators.required]),
      deudaDirecta: new FormControl(pasivo?.deudaDirecta ? pasivo?.deudaDirecta : false),
      monto: new FormControl(pasivo?.monto, [Validators.required]),
      valorCuotaMensual: new FormControl(pasivo?.valorCuotaMensual, [Validators.required]),
    });
    this.formArray.push(nuevoPasivo);
  }

  eliminarPasivo(index: number): void {
    if (index >= 0 && index < this.formArray.length) {
      this.formArray.removeAt(index);
    }
  }


  onSubmit() {
    if(this.persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado'){
      this.stepperService.nextStep();  
      return;
    }
    if(this.formArray.length == 1 && this.formArray.at(0).get('institucion')?.value == null) {
      this.stepperService.nextStep();
      return;
    }
    if(!this.formArray.invalid) {
      this.removeNullGuid();
      const formData = this.formArray.value;
      var url = `estado-situacion/${this.personaService.getPersonaGuid()}/pasivos`;
      this.dataService.postData(formData, url).subscribe({
        next: (v) => {
            this.stepperService.nextStep();
        },
        error: (e) => console.log(e),
        complete: () => {
          this.personaService.setPersona();
        },
      });
    }else{
      console.log(this.formArray.errors);
      this.formArray.markAllAsTouched();
    }
  }

  removeNullGuid() {
    for (let i = 0; i < this.formArray.length; i++) {
      if(this.formArray.at(i).get('guid')?.value == null) {
        this.formArray.at(i).removeControl('guid');
      }
    }
  }

  getTipoInstitucionKeys() {
    return Object.keys(TipoInstitucion).sort();
  }

  getTipoCreditoKeys() {
    return Object.keys(TipoCredito).sort();
  }

  volver(){
    this.stepperService.prevStep();
  }
}